<template>
  <div>
    <v-col cols="12" md="6" sm="10" class="mx-auto">
      <v-card
        shaped
        elevation="5"
        class="mx-auto error-message"
        max-width="400"
      >
        <v-col cols="12" md="12" sm="12">
          <v-img
            src="/img/alert.png"
            class="logo mx-auto"
            contain
            width="150"
            height="100"
          />
        </v-col>
        <v-col cols="12" md="7" sm="12" class="mx-auto">
          <p class="text-center body-1 font-weight-bold">
            While we are trying to fetch latest game's data, you can go and
            checkout
            <router-link
              v-if="defaultSport == 1"
              :to="{ name: 'NbaNews' }"
              class="green--text body-1 font-weight-bold"
            >
              Insights Page.
            </router-link>
            <router-link
              v-if="defaultSport == 2"
              :to="{ name: 'MlbDailyLineups' }"
              class="green--text body-1 font-weight-bold"
            >
              Insights Page.
            </router-link>
            <router-link
              v-if="defaultSport == 3"
              :to="{ name: 'NhlNews' }"
              class="green--text body-1 font-weight-bold"
            >
              Insights Page.
            </router-link>
            <router-link
              v-if="defaultSport == 4"
              :to="{ name: 'NflNews' }"
              class="green--text body-1 font-weight-bold"
            >
              Insights Page.
            </router-link>
          </p>
        </v-col>
      </v-card>
    </v-col>
  </div>
</template>

<script>
export default {
  name: "maintenance",
  props: ["defaultSport"],
};
</script>

<style scoped>
.error-message {
  margin-top: 10%;
}
</style>
